import {qspost} from '@/plugins/axios'
/*公共*/

export const allMember = (id, user_id) => qspost('/Admin/User/getUserListAll', {id, user_id})

/*
 * 统计用户的 会员数量   待审核数量   待续费数量
 * @constructor jack
 * */
export const tongJiUserNumber = () => qspost('/Admin/tongji/tongJiUserNumber', {})

/*
 * 会员人数统计
 * @constructor jack
 * */
export const getUserNumberStatistics = () => qspost('/Admin/tongji/getUserNumberStatistics', {})


/*
 * 会员人数统计
 * @constructor jack
 * */
export const getUserNumberStatisticsPersonal = () => qspost('/Admin/tongji/getUserNumberStatisticsPersonal', {})


/*
 * 会员地区人数统计
 * @constructor jack
 * */
export const getUserNumberStatisticsByRegion = () => qspost('/Admin/tongji/getUserNumberStatisticsByRegion', {})



/*
 * 会员地区人数统计
 * @constructor jack
 * */
export const getUserNumberStatisticsByRegionPersonal = () => qspost('/Admin/tongji/getUserNumberStatisticsByRegionPersonal', {})



/*
 * 会员地区人数统计
 * @constructor jack
 * */
export const getUserNumberAddress = () => qspost('/', {})


/*
 * 会员等级统计
 * @constructor jack
 * */
export const getUserGradeStatistics = () => qspost('/Admin/tongji/getUserGradeStatistics', {})

/*
 * 会员续费统计
 * @constructor jack
 * */
export const userRenewStatistics = () => qspost('/Admin/tongji/userRenewStatistics', {})


/*
 * 会员续费统计
 * @constructor jack
 * */
export const userRenewStatisticsPersonal = () => qspost('/Admin/tongji/userRenewStatisticsPersonal', {})



/*
 * 统计机构数据  通知公告、机构动态、活动管理、服务申请
 * @constructor jack
 * */
export const jiGouShuJu = () => qspost('/Admin/tongji/jiGouShuJu', {})








/*
 * 通知公告-列表
 * @constructor jack
 * */
export const noticeList = (page, limit, keyword) => qspost('/Admin/Notice/getList', {page, limit, keyword})

/*
 * 通知公告-未读人员列表
 * @constructor jack
 * */
export const getNotReadList = (id, type) => qspost('/Admin/Notice/getNotReadList', {id, type})

/*
 * 通知公告-未读人员提醒
 * @constructor jack
 * */
export const noticeRemind = (id, user_id) => qspost('/Admin/Notice/remind', {id, user_id})


/*
 * 通知公告-详情
 * @constructor jack
 * */
export const noticeDetail = (id) => qspost('/Admin/Notice/detail', {id})

/*
 * 通知公告-反馈
 * @constructor jack
 * */
export const getNoticeFeedback = (isFeedback,searchKey,id) => qspost('/Admin/Notice/getFeedback', {isFeedback,searchKey,id})

/*
 * 通知公告-标签选择
 * @constructor jack
 * */
export const labelSelect =() => qspost('/Admin/Customlable/getOrgToUserLableAll', {})

/*
 * 通知公告-发布
 * @constructor jack
 * */
export const noticeAdd = (title,is_feedback,content,fileJson,ids,feedbackJson) => qspost('/admin/Notice/setInfo', {title,is_feedback,content,fileJson,ids,feedbackJson})

/*
 * 通知公告-修改
 * @constructor jack
 * */
export const noticeEdit = (title,content,fileJson,ids,id) => qspost('/Admin/Notice/setInfo', {title,content,fileJson,ids,id})

/*
 * 通知公告-删除
 * @constructor jack
 * */
export const noticeDel = (id) => qspost('/Admin/Notice/del', {id})


/*
 * 短信发送-列表
 * @constructor jack
 * */
export const messageList = () => qspost('/Admin/Sendsms/send_sms_log', {})

/*
 * 短信发送-短信模版获取
 * @constructor jack
 * */
export const getSmsDemoList = () => qspost('/Admin/Sendsms/smsList', {})

/*
 * 短信发送-短信发送
 * @constructor jack
 * */
export const sendMessage = (message,template_id,user_id) => qspost('/Admin/Sendsms/sendMessage', {message,template_id,user_id})


/*会员管理*/

/*
 * 会员管理-列表
 * @constructor jack
 * */
export const membersList = (page,limit,keyword,rank_id,status,time,is_locking) => qspost('/Admin/User/getList', {page,limit,keyword,rank_id,status,time,is_locking})


/*会员管理*/

/*
 * 会员管理-列表
 * @constructor jack
 * */
export const membersPersonalList = (page,limit,keyword,rank_id,status,time,is_locking) => qspost('/Admin/Personal/getList', {page,limit,keyword,rank_id,status,time,is_locking})

/*
 * 会员管理-会员锁定与解锁
 * @constructor jack
 * */
export const memberSet = (user_id,state) => qspost('/Admin/User/setState', {user_id,state})


/*
 * 会员管理-会员证书
 * @constructor jack
 * */
export const memberCertificate = (userId) => qspost('/Admin/User/getUserZhengShu', {userId})


/*
 * 会员管理-会员删除
 * @constructor jack
 * */
export const memberDel = (id) => qspost('/Admin/User/del', {id})


/*
 * 会员管理-会员添加
 * @constructor jack
 * */
export const memberAdd = (userMoreJson,end_time,user_id,userType) => qspost('/Admin/User/setUser', {userMoreJson,end_time,user_id,userType})

/*
 * 会员管理-会员详情
 * @constructor jack
 * */
export const memberDetail = (user_id) => qspost('/Admin/User/getDetail', {user_id})


/*
 * 会员管理-审核列表
 * @constructor jack
 * */
export const checkList = (page,limit,name,rank_id) => qspost('/Admin/User/getCheckList', {page,limit,name,rank_id})



/*
 * 会员管理-会员审核详情
 * @constructor jack
 * */
export const getApplyUserData = (id) => qspost('/Admin/User/getApplyUserData', {id})

/*
 * 会员管理-会员审核详情修改
 * @constructor jack
 * */
export const memberApplyEdit = (userMoreJson,id) => qspost('/Admin/User/setApplyUser', {userMoreJson,id})

/*
 * 会员管理-会员审核通过/拒绝
 * @constructor jack
 * */
export const memberCheck = (id,status,examineMsg) => qspost('/Admin/User/setCheck', {id,status,examineMsg})




/*会员设置*/
/*
 * 级别管理-列表
 * @constructor jack
 * */
export const getRankList = () => qspost('/Admin/User/getRankList', {})
/*
 * 级别管理-添加
 * @constructor jack
 * */
export const setRank = (name, price, id = '') => qspost('/Admin/User/setRank', {name, price, id})
/*
 * 级别管理-删除
 * @constructor jack
 * */
export const delRank = (id) => qspost('/Admin/User/delRank', {id})

/*
 * 标签管理-自定义标签列表
 * @constructor jack
 * */
export const customList = () => qspost('/Admin/Customlable/getRankList', {})

/*
 * 标签管理-内置标签详情
 * @constructor jack
 * */
export const labelDetail = (rankId) => qspost('/Admin/User/getRankUserList', {rankId})

export const getUserFixedLableByFixedId = (fixedId) => qspost('/Admin/Customlable/getUserFixedLableByFixedId', {fixedId})




/*
 * 标签管理-自定义标签详情
 * @constructor jack
 * */
export const customDetail = (lableId) => qspost('/Admin/Customlable/getRankUserList', {lableId})

/*
 * 标签管理-自定义标签编辑
 * @constructor jack
 * */
export const customEdit = (name,userId,id) => qspost('/Admin/Customlable/addAndUpdateCustomLable', {name,userId,id})

/*
 * 标签管理-自定义标签删除
 * @constructor jack
 * */
export const customDel = (id) => qspost('/Admin/Customlable/delCustomLable', {id})


/*
* 信息管理-自定义表单获取
*
* */
export const getInformation = () => qspost('/Admin/user/getUserMoreJson', {})

/*
* 信息管理-自定义表单获取
*
* */
export const getPersonalInformation = () => qspost('/Admin/Personal/getUserMoreJson', {})

/*
* 信息管理-自定义表单提交
*
* */
export const saveInformation = (userMoreJson) => qspost('/Admin/user/addAndEditUserMoreJson', {userMoreJson})

/*
* 信息管理-自定义表单提交
*
* */
export const savePersonalInformation = (userMoreJson) => qspost('/Admin/Personal/addAndEditUserMoreJson', {userMoreJson})

/*会员说明*/

/*
 * 会员说明-详情
 * @constructor jack
 * */
export const explainDetail = (type) => qspost('/Admin/Article/getInfo', {type})

/*
 * 会员说明-提交
 * @constructor jack
 * */
export const explainEdit = (type,content) => qspost('/Admin/Article/edit', {type,content})

/*
 * 证书管理-证书展示
 * @constructor jack
 * */
export const certificateShow = (userType) => qspost('/Admin/zhengshu/getZhengShuBase', {userType})

/*
 * 证书管理-证书上传
 * @constructor jack
 * */
export const certificateUp = () => qspost('/Admin/zhengshu/getZhengShuBase', {})

/*
 * 证书管理-证书保存
 * @constructor jack
 * */
export const certificateSave = (type,fileUrl,userType) => qspost('/Admin/zhengshu/saveZhengShuBase', {type,fileUrl,userType})




/*
 * 常见问题列表
  * * @constructor jack
 * */
export const getQuestionList = (page, limit, keyword) => qspost('Admin/Commonproblem/getList', {page, limit, keyword})

/*
 * 添加/修改常见问题
  * * @constructor jack
 * */
export const addQuestion = (id, title, content,key_word) => qspost('Admin/Commonproblem/setInfo', {id, title, content,key_word})


/*
 * 删除常见问题
  * * @constructor jack
 * */
export const delQuestion = (id) => qspost('Admin/Commonproblem/del', {id})

/*
 * 客服列表
  * * @constructor jack
 * */
export const getKefuList = () => qspost('Admin/Index/getKefuList', {})

/*
 * 删除客服
  * * @constructor jack
 * */
export const delKefu = (id) => qspost('Admin/Index/delKefu', {id})

/*
 * 添加客服
  * * @constructor jack
 * */
export const addKefu = (id,name,phone) => qspost('Admin/Index/setKefu', {id,name,phone})


/*
 * 意见反馈列表
  * * @constructor jack
 * */
export const getMessageList = (page, limit) => qspost('Admin/Message/getList', {page, limit})

/*
 * 删除意见反馈
  * * @constructor jack
 * */
export const replyMessage = (id,content) => qspost('Admin/Message/remark', {id,content})

/*
 * 删除意见反馈
  * * @constructor jack
 * */
export const delMessage = (id) => qspost('Admin/Message/del', {id})


/*
 * 机构信息
  * * @constructor jack
 * */
export const getParentInfo = () => qspost('Admin/Index/getParentInfo', {})

/*
 * 机构信息
  * * @constructor jack
 * */
export const setParentInfo = (morglogo,morgname,contacts,morgtel,address,morgemail
                              ,morgurl,morgdesc) => qspost('Admin/Index/setParentInfo', {
    morglogo,morgname,contacts,morgtel,address,morgemail,morgurl,morgdesc
})

/*
 * 机构动态列表
  * * @constructor jack
 * */
export const getActiveList = (page, limit, keyword) => qspost('admin/Noticeactive/query', {page, limit, keyword})


/*
 * 删除动态
  * * @constructor jack
 * */
export const delActive = (ids) => qspost('admin/Noticeactive/del', {ids})

/*
 * 添加动态
  * * @constructor jack
 * */
export const addActive = (title,content,images) => qspost('admin/Noticeactive/add', {
    title,content,images
})

/*
 * 编辑动态
  * * @constructor jack
 * */
export const editActive = (id,title,content,images) => qspost('admin/Noticeactive/edit', {
    id,title,content,images
})

/*
 * 动态
  * * @constructor jack
 * */
export const getActiveDetail = (id) => qspost('admin/Noticeactive/detail', {id})


/*
 * 机构活动
  * * @constructor jack
 * */
export const getMeetings = (page,limit) => qspost('Admin/Meeting/getList', {page,limit})

/*
 * 服务列表
  * * @constructor jack
 * */
export const getServerList = () => qspost('Admin/Server/getTypeList', {})

/*
 * 编辑提交数据
  * * @constructor jack
 * */
export const editServer = (id,title,desc,label,son_title,son_content,son_id) => qspost('Admin/Server/edit', {id,title,desc,label,son_title,son_content,son_id})

/*
 * 服务-详情
  * * @constructor jack
 * */
export const getServerDetail = (id) => qspost('Admin/Server/detail', {id})

/*
 * 服务-详情
  * * @constructor jack
 * */
export const getServerProjectList = (sid,rankId,searchName) => qspost('Admin/server/getAppointApplyBySid', {sid,rankId,searchName})

/*
 * 删除服务列表
  * * @constructor jack
 * */
export const delServer = (id) => qspost('Admin/Server/del', {id})

/*
 * 删除记录列表
  * * @constructor jack
 * */
export const delApply = (id) => qspost('Admin/Server/delApply', {id})

/*
 * 删除记录列表
  * * @constructor jack
 * */
export const delAllApply = (serverId) => qspost('Admin/Server/delApplyAll', {serverId})

/*
 * 处理记录
  * * @constructor jack
 * */
export const changeServerApply = (id) => qspost('Admin/Server/changeServerApply', {id})

/*
 * 会员服务排序
  * * @constructor jack
 * */
export const sortServer = (id,sort) => qspost('Admin/Server/setSort', {id,sort})

/*
 * 支付列表
  * * @constructor jack
 * */
export const getOrderList = (search,page,limit) => qspost('admin/order/query', {search,page,limit})


/*
 * 支付状态
  * * @constructor jack
 * */
export const setIsPayState = (order_number,is_pay) => qspost('admin/order/setIsPayState', {order_number,is_pay})


/*
 * 开票状态
  * * @constructor jack
 * */
export const setInvoiceState = (order_number,invoice_state) => qspost('admin/order/setInvoiceState', {order_number,invoice_state})


/*
 * 发票管理列表
  * * @constructor jack
 * */
export const getInvoiceList = (start_time,end_time,page,limit) => qspost('Admin/User/getInvoiceList', {start_time,end_time,page,limit})


/*
 * 微信商户信息
  * * @constructor jack
 * */
export const getWxPayInfo = () => qspost('admin/wechat/wechatConfig_index', {})

/*
 * 设置微信商户信息
  * * @constructor jack
 * */
export const setWxPayInfo = (wx_appid,wx_mch_id,wx_apikey) => qspost('admin/wechat/wechatConfig_update', {wx_appid,wx_mch_id,wx_apikey})

/*
 *  缴费信息列表
 * @constructor jack
 * */

export const getPayLog = (user_id) => qspost('admin/User/getPayLog', {user_id})